var $name="shell/registry/ModuleUnit",$path="app/modules/shell/registry/ModuleUnit.js",$this={$name,$path,};import ModuleContext from './ModuleContext';
import Unit from './Unit';

export default class Module extends Unit {
  constructor(source, callback) {
    super(source, callback);
    super.createContext(ModuleContext, this);
  }
}
